import React from 'react';
const Layout = require('./src/components/Layout').default;

export const wrapPageElement = ({ element, props }: any) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>;
};
